// Resolves a Manchester Metrolink line colour for a given destination, using
// the schematic map's own line colours (so card accents match the map).
//
// A tram's "line" is identified by its destination: each physical line in
// manchester.json terminates at two stops, so we map each terminus to its
// line's colour. Short-run destinations (turn-back points that aren't a
// terminus) fall back to the colour of any line that serves them.

const normalize = (name) =>
  String(name)
    .replace(/[0-9]/g, "")
    .replace(/\s+/g, "")
    .trim()
    .toLowerCase();

export function createLineColourResolver(tramData) {
  const terminusColour = {}; // terminus stop -> line colour
  const anyColour = {};      // stop -> first line colour that serves it

  for (const line of tramData.lines) {
    const named = line.nodes.filter((node) => node.name);
    if (named.length === 0) continue;

    const first = normalize(named[0].name);
    const last = normalize(named[named.length - 1].name);

    if (first && !(first in terminusColour)) terminusColour[first] = line.color;
    if (last && !(last in terminusColour)) terminusColour[last] = line.color;

    for (const node of named) {
      const key = normalize(node.name);
      if (key && !(key in anyColour)) anyColour[key] = line.color;
    }
  }

  return function resolveLineColour(destinationName) {
    if (!destinationName) return null;
    // Through-services carry a "via" suffix (e.g. "Piccadilly via MediaCityUK");
    // colour by the primary destination.
    const primary = String(destinationName).split(/\s+via\s+/i)[0];
    const key = normalize(primary);
    if (!key) return null;
    return terminusColour[key] ?? anyColour[key] ?? null;
  };
}
